/* globals _ */

import api from './api';

const { noop } = _;

export default function( request, callback ) {
	callback = callback || noop;

	api( 'google/geocode', request, response => {
		callback( response.results, response.status );
	} );
}
